import { stripLoginId } from '../utils';

// ─── v4 API — Authenticated trading WebSocket (OTP URL) ───────────────────────

export const buyContract = (contractId, price) => ({
    buy: contractId,
    price,
});

export const buyContractParams = (params, price) => ({
    buy: 1,
    price,
    parameters: stripLoginId(params),
});

export const sellContract = (contractId, price) => ({
    sell: contractId,
    price,
});

export const cancel = (contractId) => ({ cancel: contractId });

export const contractUpdate = (contractId, parameters) => ({
    contract_update: 1,
    contract_id: contractId,
    ...parameters,
});

export const contractUpdateHistory = (contractId, options = {}) => ({
    contract_update_history: 1,
    contract_id: contractId,
    ...options,
});

export const contractsList = (options = {}) => ({ contracts_list: 1, ...options });

// ─── Bot/auto-trading endpoints ────────────────────────────────────────────────

/**
 * Retrieve details for a specific automated trading run.
 *
 * @param {string} runId - The run ID to retrieve (e.g. 'atr_a1b2c3d4e5f6...').
 *   Note: this is a *run* ID, not a strategy ID. Use `autoStart` to begin a run
 *   and obtain its run_id from the response.
 * @param {{ subscribe?: 1, passthrough?: object, req_id?: number }} [options]
 */
export const autoGet = (runId, options = {}) => ({ auto_get: 1, run_id: runId, ...options });
export const autoList = () => ({ auto_list: 1 });
export const autoListStrategies = () => ({ auto_list_strategies: 1 });
export const autoPause = (strategyId) => ({ auto_pause: 1, strategy_id: strategyId });
export const autoResume = (strategyId) => ({ auto_resume: 1, strategy_id: strategyId });
export const autoStart = (strategyId, options = {}) => ({ auto_start: 1, strategy_id: strategyId, ...options });
export const autoStop = (strategyId) => ({ auto_stop: 1, strategy_id: strategyId });

// ─── v3-only — Not available on v4 OTP connections ────────────────────────────

/**
 * @deprecated v3 only. The v4 API replaces this WebSocket message with the
 * REST endpoint `POST /trading/v1/options/contracts/bulk-purchase/{real,demo}`.
 * Use `DerivREST.bulkPurchase(appId, accountType, contractParameters, accounts)`
 * instead — it accepts per-account Personal Access Tokens (PATs) in the body
 * and requires only the `Deriv-App-ID` header (no OAuth Bearer token).
 */
export const buyContractForMultipleAccounts = (options = {}) => {
    const {
        price,
        tokens,
        parameters,
        passthrough,
    } = options;

    return {
        buy_contract_for_multiple_accounts: 1,
        price,
        tokens,
        parameters: stripLoginId(parameters),
        passthrough,
    };
};

/**
 * @deprecated v3 only. `sell_expired` is not available in the Deriv v4 API.
 */
export const sellExpiredContracts = () => ({
    sell_expired: 1,
});

/**
 * @deprecated v3 only. `topup_virtual` is not available in the Deriv v4 API.
 * Use `POST /trading/v1/options/accounts/{accountId}/reset-demo-balance` via
 * `DerivREST.resetDemoBalance` instead.
 */
export const topUpVirtualAccount = () => ({
    topup_virtual: 1,
});
